var _a;
import { PaymentBrand } from '../types';
var PaymentBrandToNameMap = (_a = {},
    _a[PaymentBrand.AMEX] = { shortName: 'AMEX', longName: 'AMEX' },
    _a[PaymentBrand.VISA] = { shortName: 'Visa', longName: 'Visa' },
    _a[PaymentBrand.MASTERCARD] = {
        shortName: 'Mastercard',
        longName: 'Mastercard',
    },
    _a[PaymentBrand.DISCOVER] = { shortName: 'Discover', longName: 'Discover' },
    _a[PaymentBrand.JCB] = { shortName: 'JCB', longName: 'JCB' },
    _a[PaymentBrand.DINERS] = { shortName: 'Diners', longName: 'Diners' },
    _a[PaymentBrand.CARTE_BLUE] = {
        shortName: 'CARTE BLEUE',
        longName: 'CARTE BLEUE',
    },
    _a[PaymentBrand.ELO] = { shortName: 'Elo', longName: 'Elo' },
    _a[PaymentBrand.SOLO] = { shortName: 'Solo', longName: 'Solo' },
    _a[PaymentBrand.UNIONPAY] = { shortName: 'UnionPay', longName: 'UnionPay' },
    _a[PaymentBrand.SEPA_DIRECT_DEBIT] = {
        shortName: 'SEPA',
        longName: 'SEPA Direct Debit',
        localeOverride: {
            fr: {
                shortName: 'SEPA',
                longName: 'Prélèvement SEPA',
            },
            pt: {
                shortName: 'SEPA',
                longName: 'Débito Direto SEPA',
            },
            de: {
                shortName: 'SEPA',
                longName: 'SEPA-Lastschrift',
            },
            es: {
                shortName: 'SEPA',
                longName: 'Adeudo directo SEPA',
            },
            vi: {
                shortName: 'SEPA',
                longName: 'Ghi nợ trực tiếp SEPA',
            },
        },
    },
    _a[PaymentBrand.MP_OXXO] = { shortName: 'OXXO', longName: 'OXXO' },
    _a[PaymentBrand.MP_BANAMEX] = {
        shortName: "Banamex",
        longName: "Banamex",
        localeOverride: {
            pt: {
                shortName: 'Citibanamex',
                longName: 'Citibanamex',
            },
            es: {
                shortName: 'Citibanamex',
                longName: 'Citibanamex',
            },
        },
    },
    _a[PaymentBrand.MP_BANCOMER] = {
        shortName: "Bancomer",
        longName: "Bancomer",
        localeOverride: {
            pt: {
                shortName: 'BBVA Bancomer',
                longName: 'BBVA Bancomer',
            },
            es: {
                shortName: 'BBVA Bancomer',
                longName: 'BBVA Bancomer',
            },
        },
    },
    _a[PaymentBrand.MP_SERFIN] = { shortName: "Serfin", longName: "Serfin" },
    _a[PaymentBrand.BOLETO] = {
        shortName: "Boleto Banc\u00E1rio",
        longName: "Boleto Banc\u00E1rio",
    },
    _a[PaymentBrand.BANK_TRANSFER] = {
        shortName: "Netbanking",
        longName: "Netbanking",
    },
    _a[PaymentBrand.MERCADO_PAGO_RECURRING] = {
        shortName: "Mercado Pago",
        longName: "Mercado Pago",
    },
    _a[PaymentBrand.CREDITS_PREPAID_CARD] = {
        shortName: "Credits Prepaid Card",
        longName: "Credits Prepaid Card",
    },
    _a[PaymentBrand.REG_DOT_RU] = { shortName: "Reg.ru", longName: "Reg.ru" },
    _a[PaymentBrand.MAESTRO] = { shortName: "MAESTRO", longName: "MAESTRO" },
    _a[PaymentBrand.SOFORT] = { shortName: "Sofort", longName: "Sofort" },
    _a[PaymentBrand.PAYPAL] = { shortName: "PayPal", longName: "PayPal" },
    _a[PaymentBrand.ENROUTE] = { shortName: "Enroute", longName: "Enroute" },
    _a[PaymentBrand.YANDEX] = { shortName: "Yandex", longName: "Yandex" },
    _a[PaymentBrand.BANCARD] = { shortName: "Bancard", longName: "Bancard" },
    _a[PaymentBrand.UNKNOWN] = { shortName: "Unknown", longName: "Unknown" },
    _a);
export var paymentBrandName = function (paymentBrand, locale) {
    var brandObject = PaymentBrandToNameMap[paymentBrand];
    if (brandObject) {
        var localeOverride = brandObject.localeOverride, longName = brandObject.longName, shortName = brandObject.shortName;
        if (localeOverride && localeOverride[locale]) {
            return localeOverride[locale];
        }
        return { longName: longName, shortName: shortName };
    }
    return { longName: '', shortName: '' };
};
//# sourceMappingURL=paymentBrandName.js.map